/** MEMORY_ISLAND_RITUAL — the nameless island at grey dawn. */
import type { DialogueData } from '@/core/types/contracts';
import { SPEAKER } from '../actors';
import { letter, linear, narr, say } from './util';

export const ISLAND_DIALOGUES: DialogueData[] = [
  linear('prologue-island-landing', [
    say(SPEAKER.captain, '这是哪儿？我从来不知道这里。'),
    letter('也许是他的生意没有做到这里吧？'),
    say(SPEAKER.captain, '都下船看看。'),
  ]),
  // Optional talk: the captain, his spices, and the candles of 长阳城.
  {
    id: 'prologue-island-captain',
    start: 'spice',
    nodes: [
      { id: 'spice', speaker: SPEAKER.captain, text: '来来，看看这个——香料，好东西！我跟你说，中原人肯定没闻过。', condition: { notMark: 'talked:captain-candles' }, elseNext: 'again', next: 'ask' },
      { id: 'ask', speaker: SPEAKER.jiang, text: '船长，你去过长阳城吗？', next: 'never' },
      { id: 'never', speaker: SPEAKER.captain, text: '长阳城？还没去过。你们那儿……是个什么样的地方？', next: 'candles' },
      { id: 'candles', speaker: SPEAKER.jiang, text: '我也没去过呢。听说那里一到晚上，整个城都点着蜡烛。', next: 'envy' },
      { id: 'envy', speaker: SPEAKER.captain, emotion: 'surprised', text: '真的吗？你们那里晚上整个城都用蜡烛？这得花多少钱啊？', next: 'cheap' },
      { id: 'cheap', speaker: SPEAKER.jiang, text: '蜡烛很便宜的。', next: 'dream' },
      { id: 'dream', speaker: SPEAKER.captain, emotion: 'dreamy', text: '便宜……便宜好啊……', setMark: 'talked:captain-candles', next: 'dreamNarr' },
      { id: 'dreamNarr', text: '船长显然陶醉在以后做生意的憧憬中。' },
      { id: 'again', speaker: SPEAKER.captain, emotion: 'dreamy', text: '蜡烛……便宜……嘿嘿……' },
    ],
  },
  linear('prologue-observe-island-shore', [
    narr('灰白的海。雨停了，风浪也停了。'),
  ]),
  linear('prologue-observe-island-ship', [
    narr('船停在浅水里。桅杆上还挂着昨夜的水。'),
  ]),
  linear('prologue-island-rite', [
    say(SPEAKER.captain, '卢宝丁巫师，劳烦您了。', { emotion: 'respect' }),
    narr('那个穿得破破烂烂的人走到沙滩上，用木桩摆了一个五角形状，然后将它们之间两两连接。'),
    narr('他嘴里不知道念叨些什么……'),
  ]),
  linear('prologue-island-rite-result', [
    say(SPEAKER.lubaoding, '朝西南方', { emotion: 'tired' }),
    narr('那个穿得很破烂的人显得很疲惫。'),
  ]),
  // the captain bows (art pose) between the two dialogues
  linear('prologue-island-rite-thanks', [
    say(SPEAKER.captain, '感谢你，卢宝丁巫师。', { emotion: 'respect' }),
    say(SPEAKER.captain, '都上船！往西南方走！'),
  ]),
];
